type ApiNotifier = (message: string) => void;

export type ApiActionNotification = {
  message: string;
  actionLabel: string;
  actionTo: string;
  variant?: 'success' | 'gold';
};

type ApiActionNotifier = (payload: ApiActionNotification) => void;

let notifier: ApiNotifier | null = null;
let actionNotifier: ApiActionNotifier | null = null;
let pendingMessage: string | null = null;
let pendingAction: ApiActionNotification | null = null;
let lastMessage = '';
let lastNotifyAt = 0;

const DEDUPE_MS = 4000;

export const registerApiNotifier = (next: ApiNotifier | null): void => {
  notifier = next;
  if (next && pendingMessage) {
    const queued = pendingMessage;
    pendingMessage = null;
    notifyApiUser(queued);
  }
};

export const registerApiActionNotifier = (next: ApiActionNotifier | null): void => {
  actionNotifier = next;
  if (next && pendingAction) {
    const queued = pendingAction;
    pendingAction = null;
    notifyApiUserAction(queued);
  }
};

export const notifyApiUser = (message: string): void => {
  const trimmed = message.trim();
  if (!trimmed) {
    return;
  }

  if (!notifier) {
    pendingMessage = trimmed;
    return;
  }

  const now = Date.now();
  if (trimmed === lastMessage && now - lastNotifyAt < DEDUPE_MS) {
    return;
  }

  lastMessage = trimmed;
  lastNotifyAt = now;
  notifier(trimmed);
};

export const notifyApiUserAction = (payload: ApiActionNotification): void => {
  if (!payload.message.trim()) {
    return;
  }

  if (!actionNotifier) {
    pendingAction = payload;
    return;
  }

  actionNotifier(payload);
};
